<template>
  <div class="page-years-sale-names" :class="{ 'blue-bg': is_from_ai }">
    <!-- AI识别相关车型结果 -->
    <div v-if="is_from_ai" class="vehicle-info">
      <img
        class="vehicle-icon"
        :src="
          brand_logo_url ||
          'https://oss-shell-elite-store.vchangxun.com/shop-wxapp/v3.2.0/default_car_logo.png'
        "
      />
      <div class="info-box">
        <div class="vehicle-name">
          {{ $route.query.brand_name }}- {{ $route.query.factory_name
          }}{{ $route.query.model_alias }}
        </div>
        <div class="license-plate">
          车牌号：{{ decodeURIComponent($route.query.license_plate) }}
        </div>
      </div>
    </div>
    <!-- 车型名称 -->
    <div
      :class="{
        'selected-vehicle-name': true,
        h58: !is_from_ai,
        'no-bg': is_from_ai,
      }"
    >
      <img
        class="logo"
        :src="
          brand_logo_url ||
          'https://oss-shell-elite-store.vchangxun.com/shop-wxapp/v3.2.0/default_car_logo.png'
        "
      />
      <div :class="{ 'vehicle-name': true, 'blue-color': is_new_energy == 1 }">
        {{ vehicle_name }}
      </div>
      <div v-if="is_from_ai" class="horizontal-line"></div>
    </div>
    <!-- 可供选择的款型列表 -->
    <div class="years-sale-name-list">
      <div class="subtitle">
        <img
          v-if="is_new_energy == 1"
          class="rect-icon"
          src="@/assets/maintain/square_fold_blue.png"
        />
        <img v-else class="rect-icon" src="@/assets/maintain/square_fold.png" />
        <div
          class="subtitle-text"
          :class="is_new_energy == 1 ? 'blue-color' : ''"
        >
          请选择车型
        </div>
      </div>
      <div
        class="years-sale-names-item"
        @click="
          toSelectVehicle(item.release_year, item.sales_name, item.model_name)
        "
        v-for="(item, index) in years_sale_names"
        :key="index"
      >
        {{ item.release_year }} {{ item.sales_name }}
        <span v-if="item.fuel_type != '柴油' && item.fuel_type != '汽油'"
          >（{{ item.fuel_type }}）</span
        >
        <span>{{ item.model_name || "" }}</span>
      </div>
    </div>
    <!-- 车型备注弹出层部分 -->
    <div class="popup-mask" v-show="showPopup"></div>
    <div :class="{ height0: !showPopup, 'popup-content': true }">
      <div class="content" v-show="showPopup">
        <div class="title">
          <span class="left">
            <span>{{ popupTitle }}</span>
          </span>
          <i
            class="close iconfont icon-guanbi font-10 color-grayC"
            @click.stop="cancelChoose"
          ></i>
        </div>
        <div class="sub-list">
          <div
            :class="{ subItem: true, multiple: item.multiple }"
            v-for="(item, index) in popupList"
            :key="index"
            @click="itemClickHandler(item)"
          >
            <span v-html="item.text"></span
            ><i class="iconfont icon-arrowR font-10 color-grayC" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/apis/maintenance-api.js";
import validToken from "@/mixins/valid-token.js";
import checkNotes from "../../mixins/check-notes";
export default {
  name: "years-sale-names",
  mixins: [validToken, checkNotes],
  data() {
    return {
      vehicle_name: "",
      years_sale_names: [],
      args: {},
      is_new_energy: "", // 是否为新能源
      is_from_ai: false, // 是否从AI识图页面跳转过来的
      dynamic_vehicle_ids: [],
      brand_logo_url: "",
    };
  },
  mounted() {
    const {
      brand_name,
      factory_name,
      model_alias,
      displacement,
      is_new_energy,
      license_plate,
      brand_logo_url,
    } = this.$route.query;
    console.log(decodeURIComponent(license_plate));
    this.is_from_ai = this.$route.query.internal_from === "ai_photo";
    this.is_new_energy = is_new_energy;
    this.vehicle_name = `${brand_name} - ${factory_name} - ${model_alias} - ${displacement}`;
    this.brand_logo_url = brand_logo_url;
    this.fetchYearsAndSalesNameList();
  },
  methods: {
    /**
     * 进一步选择备注或跳转中间选择页面
     * @param {string} release_year
     * @param {string} sales_name
     * @param {String} model_name
     */
    async toSelectVehicle(release_year, sales_name, model_name) {
      console.log("release_year, sales_name", release_year, sales_name);
      const { brand_name, factory_name, model_alias, displacement } =
        this.$route.query;
      this.args = {
        brand_name,
        factory_name,
        model_alias,
        displacement,
        release_year,
        sales_name,
        model_name,
      };
      const valid_menus = JSON.parse(sessionStorage.getItem("valid_menus"));
      console.log(sessionStorage.getItem("valid_menus"));
      if (valid_menus.length >= 1) {
        if (valid_menus[0].type !== 1) {
          await this.fetchValidToken();
          if (!this.token) return;
          await this.fetchVehicleListByParams(this.args);
        }
        //只有一个开放菜单，进一步选择车型备注
        switch (valid_menus[0].type) {
          case 1:
            this.checkEngineOil();
            break;
          case 2:
            this.checkTransmissionOil();
            break;
          case 3:
            this.checkTireCategory();
            break;
          case 4:
            this.checkOilFilterCategory();
            break;
          case 5:
            this.toBrakingSystem();
            break;
          case 10:
            this.toCoolant();
            break;
          default:
            break;
        }
      } else {
        //无开放菜单或多个菜单，跳转中间选择页面
        if (!this.dynamic_vehicle_ids) {
          await this.fetchValidToken();
          if (!this.token) return;
          await this.fetchVehicleListByParams(this.args);
        }
        this.$router.push({
          path: "maintenance-detail",
          query: {
            vehicle_ids: this.dynamic_vehicle_ids_query,
            vehicle_id: this.dynamic_vehicle_ids[0],
            menu_type: 0,
            scheme_id: this.$route.query.scheme_id,
            internal_from: this.$route.query.internal_from,
          },
        });
      }
    },
    /**
     * 通过车型参数获取车型列表，更新当前页面的dynamic_vehicle_ids供检查车型备注的mixin逻辑使用
     * @param {*} params
     */
    async fetchVehicleListByParams(params) {
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      try {
        const res = await api.getModelDetail({
          ...params,
          parts_type: 1,
          token: this.token,
          scheme_id,
        });
        this.$loading.hide();
        if (res.code === 0) {
          this.dynamic_vehicle_ids = res.data.vehicle_list.map((i) => i.id);
          this.dynamic_vehicle_ids_query = encodeURIComponent(
            this.dynamic_vehicle_ids.join(",")
          );
        } else {
          this.$toast.show({
            showTime: 3,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        this.$loading.hide();
        console.log("获取车型列表失败！");
        error && console.log(error);
      }
    },
    /**
     * 获取年份款型列表
     */
    async fetchYearsAndSalesNameList() {
      this.$loading.show("加载中...");
      const { brand_name, factory_name, model_alias, displacement } =
        this.$route.query;

      try {
        const res = await api.getYearsAndSalesNameListApi({
          brand_name,
          factory_name,
          model_alias,
          displacement,
        });
        this.$loading.hide();
        if (res.code === 0) {
          this.years_sale_names = res.data;
        } else {
          this.$toast.show({
            showTime: 3,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        this.$loading.hide();
        console.log("获取年份款型列表失败！");
        error && console.log(error);
      }
    },
    toBrakingSystem() {
      this.$router.push({
        path: "maintenance-detail",
        query: {
          vehicle_id: this.dynamic_vehicle_ids[0],
          menu_type: 5,
          scheme_id: this.$route.query.scheme_id,
          internal_from: this.$route.query.internal_from,
        },
      });
    },
    toCoolant() {
      this.$router.push({
        path: "maintenance-detail",
        query: {
          vehicle_id: this.dynamic_vehicle_ids[0],
          menu_type: 10,
          scheme_id: this.$route.query.scheme_id,
          internal_from: this.$route.query.internal_from,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.page-years-sale-names {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #fafafa;
  .vehicle-info {
    display: flex;
    width: 100%;
    min-height: 179/100rem;
    background: url("https://select-oil-oss.vchangyi.com/wxapp/v1.2.0/vehicle_show_bg.png")
      center center no-repeat;
    background-color: #fff;
    background-size: 98% 100%;
    .vehicle-icon {
      width: 94/100rem;
      height: 94/100rem;
      margin: 39/100rem 36/100rem 46/100rem 43/100rem;
    }
    .info-box {
      display: flex;
      flex-direction: column;
      width: 455/100rem;
      margin-top: 41/100rem;
      padding-right: 41/100rem;
      .vehicle-name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        word-break: break-all;
        font-size: 36/100rem;
        line-height: 43/100rem;
        margin-bottom: 9/100rem;
      }
      .license-plate {
        line-height: 34/100rem;
      }
    }
  }
  .selected-vehicle-name {
    position: relative;
    color: #404040;
    font-size: 26/100rem;
    font-weight: bold;
    line-height: 38/100rem;
    display: flex;
    align-items: center;
    min-height: 108/100rem;
    padding-left: 27/100rem;
    background: #ffffff;
    box-shadow: 0px 10/100rem 27/100rem 0px rgba(239, 237, 237, 0.5);
    .logo {
      width: 48/100rem;
      height: 48/100rem;
      margin-right: 17/100rem;
    }
    .vehicle-name {
      font-weight: bold;
      color: #000;
      font-size: 26/100rem;
    }
    .logo,
    .vehicle-name {
      // margin-bottom: 29/100rem;
    }
    .horizontal-line {
      position: absolute;
      bottom: 0;
      left: 24/100rem;
      width: 592/100rem;
      height: 1/100rem;
      background-color: #979797;
    }
  }
  .no-bg {
    background: none;
  }
  .years-sale-name-list {
    display: flex;
    flex-direction: column;
    padding: 0 27/100rem;
    // box-shadow: 0px 3px 26px 0px rgba(0, 0, 0, 0.05);
    .subtitle {
      display: flex;
      margin: 34/100rem 0 17/100rem 0;
      color: #fbce07;
      font-size: 26/100rem;
      line-height: 0;
      align-items: center;
      font-weight: bold;
      .rect-icon {
        width: 26/100rem;
        height: 26/100rem;
        margin-right: 17/100rem;
      }
      .subtitle-text {
        line-height: 36/100rem;
        vertical-align: middle;
      }
      .blue-color {
        color: #b1e6ec;
      }
    }
    .years-sale-names-item {
      padding: 17/100rem 0;
      color: #404040;
      line-height: 36/100rem;
      font-size: 26/100rem;
      &:active {
        background: #f0f0f0;
      }
      &:last-child {
        margin-bottom: 40/100rem;
      }
    }
  }

  // 车型备注弹出层部分
  .popup-mask {
    position: absolute;
    top: 0;
    height: 100%;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 3;
  }
  .popup-content {
    width: 100%;
    height: 539/100rem;
    background-color: #fff;
    transition: 0.3s;
    position: fixed;
    left: 0;
    bottom: 0;
    font-size: 14px;
    z-index: 99;
    padding: 0 26/100rem;
    .content {
      overflow: auto;
      .title {
        line-height: 92/100rem;
        height: 92/100rem;
        color: #c6c6c6;
        border-bottom: 2/100rem #f6f6f6 solid;
        display: flex;
        justify-content: space-between;
        font-size: 24/100rem;
        .left {
          i {
            margin-right: 17/100rem;
          }
          span {
            i {
              margin: 0 6/100rem;
            }
          }
        }
      }
      .sub-list {
        overflow: auto;
        height: 448/100rem;
        .subItem {
          display: flex;
          justify-content: space-between;
          align-items: center;
          line-height: 40/100rem;
          // padding: 20/100rem 0;
          font-size: 26/100rem;
          min-height: 87/100rem;
          color: #404040;
          border-bottom: 2px #f6f6f6 solid;
        }
        .multiple {
          padding: 20/100rem 0;
        }
      }
    }
  }
  .height0 {
    height: 0;
  }
  .blue-color {
    color: #b1e6ec;
  }
}
.blue-bg {
  background: #f2f6f6;
}
</style>
